import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { sessionStats, heroContent } from '../mockData';
import { Card, CardContent } from './ui/card';
import { createStaggerContainer, fadeInUp, getScrollAnimationProps, scaleIn } from '../lib/animations';

const SessionSection = () => {
  const shouldReduceMotion = useReducedMotion();
  const scrollAnimationProps = getScrollAnimationProps(shouldReduceMotion, { amount: 0.25 });
  const containerVariants = shouldReduceMotion ? undefined : createStaggerContainer({ staggerChildren: 0.2, delayChildren: 0.1 });

  return (
    <motion.section id="seance" className="py-12 sm:py-16 lg:py-20 bg-[#E5DDD0]" {...scrollAnimationProps} variants={containerVariants}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div className="text-center mb-8 sm:mb-12" variants={createStaggerContainer({ staggerChildren: 0.12 })}>
          <motion.h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#5A5045] mb-3 sm:mb-4" variants={fadeInUp}>
            Votre séance de neuro-thérapie
          </motion.h2>
          <motion.p className="text-sm sm:text-base lg:text-lg text-[#6B5E54] max-w-3xl mx-auto px-4" variants={fadeInUp}>
            Un temps dédié pour comprendre vos besoins, relâcher les tensions et repartir avec des outils pour prolonger les bénéfices à la maison.
          </motion.p>
        </motion.div>

        <motion.div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12" variants={containerVariants}>
          {sessionStats.map((stat, index) => (
            <motion.div
              key={index}
              variants={scaleIn}
              whileHover={shouldReduceMotion ? undefined : { y: -6, boxShadow: '0 20px 40px rgba(125, 132, 113, 0.2)' }}
            >
              <Card className="border-none shadow-md bg-white rounded-sm">
                <CardContent className="p-6 sm:p-8 text-center">
                  <div className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#7D8471] mb-2 sm:mb-3">{stat.value}</div>
                  <p className="text-xs sm:text-sm text-[#6B5E54]">{stat.label}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="bg-white/60 p-6 sm:p-8 lg:p-10 rounded-sm border-l-4 border-[#7D8471] max-w-4xl mx-auto" variants={fadeInUp}>
          <p className="text-base sm:text-lg lg:text-xl font-serif text-[#5A5045] italic text-center leading-relaxed">
            "{heroContent.quote}"
          </p>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default SessionSection;